module.exports = __webpack_public_path__ + "static/media/Default_Brand_Image.ddb9b715.png";